<template>
  <div class="container-bg ">
    <div class="container  py-5 ">
      <div class=" p-4 filter border border-info rounded">
        <h1 class="pt-3 mb-4 text-center h1--title">Listado de Solicitudes</h1>
        <FormFilter />
        <div>
          <ItemRequest
            v-for="(data, i) in solicitudes"
            :key="data.i"
            :data="data"
            :position="i + 1"
          />
        </div>
        <div class="pagination">
          <b-pagination
            class="mt-4"
            v-model="currentPage"
            :total-rows="cantidadTotal"
            :per-page="request.cantidad"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import FormFilter from "../components/FormFilter";
import ItemRequest from "../components/ItemRequest";

export default {
  components: {
    FormFilter,
  
    ItemRequest,
  },
  data() {
    return {
      currentPage: 1,
    };
  },

  async mounted() {
    await this.getListRequest();
    this.currentPage = this.request.skip;
  },
  methods: {
    async getListRequest() {
      await this.$store.dispatch({
        type: "applyEmployer/getListRequests",
        data: this.request,
      });
    },
  },
  computed: {
    ...mapState({
      solicitudes: (state) => state.applyEmployer.response.solicitudes,
      request: (state) => state.applyEmployer.request,
      cantidadTotal: (state) => state.applyEmployer.response.cantidadTotal,
    }),
  },
  watch: {
    async currentPage() {
      this.$store.commit("applyEmployer/SET_SKIP", this.currentPage);
      await this.getListRequest();
    },
  },
};
</script>
<style>
body {
  background-image: url("../assets/vuesax-login-bg.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.filter {
  background: #ffffff;
  -webkit-box-shadow: 0px 0px 13px -1px rgba(0, 0, 0, 0.34);
  -moz-box-shadow: 0px 0px 13px -1px rgba(0, 0, 0, 0.34);
  box-shadow: 0px 0px 13px -1px rgba(0, 0, 0, 0.34);
}
.pagination {
  display: flex;
  justify-content: center;
}
</style>
